import { EffectCallback } from "react";

import useMount from "hooks/useMount";

const useUnmount = (disposer: ReturnType<EffectCallback> = () => undefined) => {
  useMount(() => disposer);
};

export default useUnmount;
